import React, { useState } from "react";
import { SortMobile } from "../sorts";
import { FilterMobile } from "../filters";
import PropTypes from "prop-types";
import CustomImage from "../../atoms/customImage";
import { plpPageConstants } from "../../../constants/pageConstants/plpConstants";
import { lockBody, unlockBody } from "../../../utils/document";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setIsFilterOpen, setIsSortOpen } from "../../../store/slices/plpSlice";

/**
 *
 * @param {*} param0
 * @returns
 */
const FilterSort = ({ sortData, facetFilter, categoryId }) => {
  const dispatch = useDispatch();
  const [filterCount, setFilterCount] = useState(0);
  const [sortApplied, setSortApplied] = useState(sortData?.[0]?.level || plpPageConstants.RECOMMENDED);
  const { mobileFilterDetail, isFilterOpen, isSortOpen } = useSelector(
    (state) => ({
      mobileFilterDetail: state?.plp?.mobileFilterDetail,
      isFilterOpen: state?.plp?.isFilterOpen,
      isSortOpen: state?.plp?.isSortOpen,
    }),
    shallowEqual,
  );
  /**
   * Opens the filter panel.
   */
  const onFilterOpen = () => {
    if (!isFilterOpen) {
      dispatch(setIsFilterOpen(true));
      lockBody();
    }
  };
  /**
   * Closes the filter panel.
   */
  const onFilterClose = () => {
    if (isFilterOpen) {
      dispatch(setIsFilterOpen(false));
    }
    unlockBody();
  };

  /**
   * Opens the sort options panel.
   */
  const onSortOpen = () => {
    if (!isSortOpen) {
      dispatch(setIsSortOpen(true));
      lockBody();
    }
  };

  /**
   * Closes the sort options panel.
   */
  const onSortClose = () => {
    if (isSortOpen) {
      dispatch(setIsSortOpen(false));
    }
    unlockBody();
  };
  return (
    <>
      <div className="flex w-full items-center justify-between">
        {sortData?.length > 0 && false && (
          <div
            className={`flex w-full flex-1 items-center gap-12 px-16 py-10 ${facetFilter?.length ? "justify-end pr-32" : "justify-center"}`}
            onClick={onSortOpen}
          >
            <CustomImage src="/icons/sort.svg" alt="sort icon" width={18} height={18} isPriority={false} sizes="10vw" />
            <div className="flex flex-col gap-4 leading-0">
              <span className="text-14 font-600 text-fnp-300">{plpPageConstants.SORT_BY}</span>
              <span className="text-10 font-500 text-grey-500">{sortApplied || plpPageConstants.RECOMMENDED}</span>
            </div>
          </div>
        )}
        {facetFilter?.length > 0 && false && (
          <>
            <div className="h-[70%] w-1 bg-grey-25" />
            <div
              className={`flex w-full flex-1 items-center gap-12 px-16 py-10 ${sortData?.length ? "justify-start pl-32" : "justify-center"}`}
              onClick={onFilterOpen}
            >
              <CustomImage
                src="/icons/filter.svg"
                alt="filter icon"
                width={18}
                height={18}
                isPriority={false}
                sizes="10vw"
              />
              <div className="flex flex-col gap-4 leading-0">
                <span className="text-14 font-600 text-fnp-300">{plpPageConstants.FILTER}</span>
                <span className="flex items-center gap-4 text-10 font-500 text-grey-500">
                  {filterCount ? (
                    <>
                      {plpPageConstants.APPLIED}
                      <span
                        className="inline-flex items-center justify-center rounded-[12px] bg-[#737530] py-[1px] pl-[5px] pr-[5px]"
                        style={{ color: "#FFFFFF" }}
                      >
                        {filterCount}
                      </span>
                    </>
                  ) : (
                    <span
                      className="font-inter text-10 font-500 leading-3 opacity-50"
                      style={{
                        color: "var(--GS5, #444)",
                        fontVariantNumeric: "lining-nums proportional-nums",
                        fontFeatureSettings: "'dlig' on",
                        fontStyle: "normal",
                      }}
                    >
                      {plpPageConstants.NOT_FILTER}
                    </span>
                  )}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
      <SortMobile
        isOpen={isSortOpen}
        onClose={onSortClose}
        data={sortData}
        categoryId={categoryId}
        selectSortName={sortApplied || plpPageConstants.RECOMMENDED}
        setSelectSortName={(sortName) => setSortApplied(sortName)}
      />
      {facetFilter && (
        <FilterMobile
          isOpen={isFilterOpen}
          onClose={onFilterClose}
          data={mobileFilterDetail?.facetDetailList || facetFilter}
          categoryId={categoryId}
          setFilterCount={(count) => setFilterCount(count)}
          filterTotalCount={mobileFilterDetail?.total}
        />
      )}
    </>
  );
};
FilterSort.propTypes = {
  sortData: PropTypes.array.isRequired,
  facetFilter: PropTypes.array,
  categoryId: PropTypes.string.isRequired,
};

export default FilterSort;
